var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outline_Old_Icons",
    "data-name": "Outline Old Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.15,7.85a.49.49,0,0,1,.7-.7L12,11.29V.5a.5.5,0,0,1,1,0V11.29l4.15-4.14a.49.49,0,1,1,.7.7l-5,5a.36.36,0,0,1-.16.11.47.47,0,0,1-.38,0,.36.36,0,0,1-.16-.11ZM24,16.5v7a.5.5,0,0,1-.5.5H.5a.5.5,0,0,1-.5-.5v-7a.41.41,0,0,1,0-.19.36.36,0,0,1,.11-.16l4-4A.47.47,0,0,1,4.5,12H8a.5.5,0,0,1,0,1H4.71l-3,3H7.5a.5.5,0,0,1,.5.5V18h8V16.5a.5.5,0,0,1,.5-.5h5.79l-3-3H17a.5.5,0,0,1,0-1h2.5a.47.47,0,0,1,.35.15l4,4a.36.36,0,0,1,.11.16A.41.41,0,0,1,24,16.5ZM23,17H17v1.5a.5.5,0,0,1-.5.5h-9a.5.5,0,0,1-.5-.5V17H1v6H23Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3a06e4e29cbbf0539a8fc301eb7fe5dc.svg";
export { ForwardRef as ReactComponent };